import React from 'react';
import classNames from 'classnames';
import styles from './SectorKPIsTableHead.module.css';

function SectorKPIsTableHead({ className, style, children }) {
  return (
    <div className={classNames(styles.root, 'rt-thead', className)} style={style}>
      {children}
    </div>
  );
}

export default SectorKPIsTableHead;
